import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import SellOrderStatusBar, { SellOrderStatusBarNew, SellOrderStatusBarProps } from '../../../SellOrderStatusBar'
import SellOrderWaitingResponseStepButtons, { SellOrderWaitingResponseStepButtonsNew, SellOrderWaitingResponseStepButtonsProps } from '../SellOrderWaitingResponseButtons'

type SellOrderWaitingResponseStepHeaderProps = & SellOrderStatusBarProps & SellOrderWaitingResponseStepButtonsProps

const SellOrderWaitingResponseStepHeaderDecider: React.FC<SellOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellOrderWaitingResponseStepHeaderDefault} NewComponent={SellOrderWaitingResponseStepHeaderNew} {...rest} />
    )
}

const SellOrderWaitingResponseStepHeaderDefault: React.FC<SellOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellOrderStatusBar {...rest} />
            <SellOrderWaitingResponseStepButtons {...rest} />
        </div>
    )
}

const SellOrderWaitingResponseStepHeaderNew: React.FC<SellOrderWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellOrderStatusBarNew {...rest} />
            <SellOrderWaitingResponseStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellOrderWaitingResponseStepHeaderDecider